import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import intl from 'react-intl-universal';
import jigsawApi from '../../actions/jigsaw';
import { toJpeg } from 'html-to-image';

import './JigsawPortal.scss';
import { IOneGallery } from 'components/GalleryList/Common';
import RootStore from 'store/RootStore';
import { inject, observer } from 'mobx-react';
import { isWeb, makeJpeg, sleep } from 'utils/util';

import ReactSVG from 'react-svg';
import { style } from 'utils/image';

interface IJigsawPortal {
  data:IOneGallery[];
  onClose: () => void;
  rootStore?:RootStore;
}

const jigsawPortalContainer = document.createElement('div');

const JigsawPortal = (props: IJigsawPortal) => {
  const {data, onClose, rootStore} = props;
  const {uiStore, galleryStore, commonStore} = rootStore!;
  const [loaded, setLoaded] = useState({} as {
    [key: string]: boolean;
  });
  const [imageData, setImageData] = useState("");

  const getLongConfig = ()=>{
    let longConfig = window.configDetail?.long_config;
    if(longConfig) {
      if(typeof longConfig == 'string') {
        try {
          longConfig = JSON.parse(longConfig);
        }catch(e) {
          longConfig = {};
        }
      }
    }else {
      longConfig = {};
    }

    return longConfig;
  }

  // useEffect(()=>{
  //   if(data && data.length) {
  //     uiStore.showToast({
  //       icon: "loading",
  //       content: intl.get("Collaging"),
  //       time: 20000,
  //     });

  //     setCreated(true);
  //   }
  // }, [data]);

  useEffect(()=>{
    if (data && data.length) {
      document.body.appendChild(jigsawPortalContainer);

      uiStore.showToast({
        icon: "loading",
        content: intl.get("Collaging"),
        time: 300000,
      });
    } else {
      if (jigsawPortalContainer && jigsawPortalContainer.parentNode)
        document.body.removeChild(jigsawPortalContainer);
    }
    return () => {
      if (jigsawPortalContainer && jigsawPortalContainer.parentNode)
        document.body.removeChild(jigsawPortalContainer);
    };
  }, [data]);

  const onImageLoad = (id:number, e:any)=>{
    if(loaded[String(id)]) {
      return;
    }
    setLoaded({
      ...loaded,
      [String(id)]:true
    });
  };

  const contentRef = useRef<HTMLDivElement>(null);

  const makeImage = async ()=>{
    if(data && data.length) {
      let totalLength = data.length;
      const longConfig = getLongConfig();
      if(longConfig?.headerImage) {
        totalLength += 1;
      }
      if(longConfig?.footerImage) {
        totalLength += 1;
      }
      if(Object.keys(loaded).length == totalLength) {
        const result = await makeJpeg(contentRef.current as HTMLElement, {
          quality:0.9,
          pixelRatio:1
        });
        uiStore.hideToast();
        uiStore.showToast({
          content:intl.get('Success'),
          time:1000
        });
        setImageData(result);
        // toJpeg(contentRef.current as HTMLElement, {
        //   quality: 0.9,
        //   // 强制设定为1，避免在mobile上宽高会被*pixelRatio
        //   pixelRatio: 1,
        // }).then(()=>{
        //   toJpeg(contentRef.current as HTMLElement, {
        //     quality: 0.9,
        //     // 强制设定为1，避免在mobile上宽高会被*pixelRatio
        //     pixelRatio: 1,
        //   }).then((dataUrl)=>{
        //     uiStore.hideToast();
        //     uiStore.showToast({
        //       content:intl.get('Success'),
        //       time:1000
        //     });
        //     setImageData(dataUrl);

        //     // 上传文件
        //     const fileKey = `poster/${data.map((it: IOneGallery)=>it.id).join('_')}.jpg`;
        //     console.log(fileKey);
        //     commonStore.uploadImage(
        //       {
        //         key: fileKey,
        //         file: dataUrl,
        //       },
        //       "base64"
        //     ).then(res=>{
        //       // 发请求吧
        //       jigsawApi.create({
        //         galleryid: window.gallery.id,
        //         imageids: JSON.stringify(data.map((it) => it.id)),
        //       });
        //     });
        //   });
        // });
      }
    }
  };

  useEffect(()=>{
    makeImage();
  }, [Object.keys(loaded).length, data]);

  const zoom = Math.min(750, (document.body.clientWidth)) / 1366;

  const renderContent = ()=>{
    if(imageData) {
      return isWeb() ? (
        <a
          href={imageData}
          download={`long.jpg`}
          target="_blank"
        >
          <img src={imageData} />
        </a>
      ) : (
        <img src={imageData} />
      );
    }

    let longConfig = getLongConfig();

    return <>
      {longConfig.headerImage ? <img key="header" crossOrigin="anonymous" src={`https:${style(longConfig.headerImage, "wx_1920_n")}`} onLoad={(e)=>onImageLoad(-1, e)} /> : null}

      {data && data.length ? data.map((it: IOneGallery)=>{
        return <img key={it.id} crossOrigin="anonymous" src={`https:` + style(it.hash, "wx_1920_n", {
          width:Number(it.width),
          height:Number(it.height),
          targetWidth:1920,
          watermark: galleryStore.getWatermarksByKey(it.galleryid,
              typeof it.show_mark != 'undefined'
                  ? it.show_mark
                  : 1
          )
        })} alt={`${it.id}`} onLoad={(e)=>onImageLoad(it.id, e)} />;
      }) : null}

      {longConfig.footerImage ? <img key="footer" crossOrigin="anonymous" src={`https:${style(longConfig.footerImage, "wx_1920_n")}`} onLoad={(e)=>onImageLoad(-2, e)} /> : null}
    </>;
  }

  return createPortal(
    <div className="jigsaw-portal">
      <div className="jigsaw-portal-mask" />
      <div className="jigsaw-portal-wrapper">
        <div className="jigsaw-portal-content" style={{zoom:zoom}}>
          <div className="jigsaw-portal-imagelist" ref={contentRef} style={{width:1366}}>
            {renderContent()}
          </div>
        </div>
        <div className="jigsaw-portal-info">
          {isWeb() ? intl.get('Click to save') : intl.get('Long-press to save')}
        </div>

        <div className="jigsaw-portal-close" onClick={props.onClose}>
          <ReactSVG
            src={require('../../svg/x.svg')}
            className="x"
            style={{ fill: '#ffffff', width: '14px', marginTop:3}}
          />
        </div>
      </div>
    </div>,
    jigsawPortalContainer
  );
};
// const JigsawPortal = (props: IJigsawPortal) => {
//   useEffect(() => {
//     if (props.url) {
//       document.body.appendChild(jigsawPortalContainer);
//     } else {
//       if (jigsawPortalContainer && jigsawPortalContainer.parentNode)
//         document.body.removeChild(jigsawPortalContainer);
//     }
//     return () => {
//       if (jigsawPortalContainer && jigsawPortalContainer.parentNode)
//         document.body.removeChild(jigsawPortalContainer);
//     };
//   });

//   let names = (props.url || '').split('/');

//   return createPortal(
//     <div className="jigsaw-portal">
//       <div className="jigsaw-portal-mask" />
//       <div className="jigsaw-portal-wrapper">
//         <div className="jigsaw-portal-content">
//           {isWeb() ? (
//             <a
//               href={window.location.protocol + props.url}
//               download={(names || []).pop()}
//               target="_blank"
//             >
//               <img src={props.url} />
//             </a>
//           ) : (
//             <img src={props.url} />
//           )}
//           {/*}<img src={props.url} onClick={()=>{
//             if(isWeb()) {
//               let names = (props.url || "").split('/');
//               downloadImage(props.url, (names || []).pop());
//             }
//           }} />*/}
//         </div>
//         <div className="jigsaw-portal-info">
//           {isWeb() ? intl.get('Click to save') : intl.get('Long-press to save')}
//         </div>

//         <div className="jigsaw-portal-close" onClick={props.onClose}>
//           <ReactSVG
//             src={require('../../svg/x.svg')}
//             className="x"
//             style={{ fill: '#ffffff', width: '14px' }}
//           />
//         </div>
//       </div>
//     </div>,
//     jigsawPortalContainer
//   );
// };

export default inject("rootStore")(observer(JigsawPortal));
